import React from "react";

const VIcon = ({ height, style }) => (
  <svg
    height={height}
    style={style}
    viewBox="0 0 66 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2136_23117)">
      <rect
        x="2.29639"
        y="0.589355"
        width="63.3704"
        height="59"
        rx="7.18683"
        fill="#EFF1F5"
      />
      <rect
        x="2.92523"
        y="1.2182"
        width="62.1127"
        height="57.7423"
        rx="6.55798"
        stroke="#212326"
        strokeWidth="1.2577"
      />
    </g>
    <path
      d="M23.3039 33.7004L18.467 18.5462H21.5186L25.5251 31.666L24.6533 31.2508H26.8953L26.0026 31.666L29.6978 18.5462H32.6456L28.1616 33.7004H23.3039Z"
      fill="#42464C"
    />
    <defs>
      <filter
        id="filter0_d_2136_23117"
        x="0.176757"
        y="0.589355"
        width="65.49"
        height="63.3704"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2.11963" dy="4.37037" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.258824 0 0 0 0 0.27451 0 0 0 0 0.298039 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2136_23117"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2136_23117"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default VIcon;
